const ResourcesList = () => import('./pages/ResourcesList.vue');
const ResourceDetail = () => import('./pages/ResourceDetail/ResourceDetail.vue');
const ResourceType = () => import('./pages/ResourceType/ResourceType.vue');
const LoginPage = () => import('@/pages/LoginPage.vue');

export default [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: { isPublic: true },
  },
  {
    path: '/',
    name: 'resources',
    component: ResourcesList,
  },
  {
    path: '/new',
    name: 'createResource',
    component: ResourceDetail,
  },
  {
    path: '/newType',
    name: 'createResourceType',
    component: ResourceType,
  },
  {
    path: '/:id',
    name: 'resourceDetail',
    component: ResourceDetail,
  },
];
